// src/components/Project.js
import { Link } from "react-router-dom";

// 카드 배경 이미지 (박스)
import box1 from "../assets/layout/images/project_box1.jpg";
import box2 from "../assets/layout/images/project_box2.jpg";
import box3 from "../assets/layout/images/project_box3.jpg";

// 카드 아이콘 이미지
import ico1 from "../assets/layout/images/project_pic1.png"; // 교량계측
import ico2 from "../assets/layout/images/project_pic2.png"; // BIM
import ico3 from "../assets/layout/images/project_pic3.png"; // 컨택센터

const Project = () => {
  const cards = [
    {
      id: "bms",
      box: box1,
      icon: ico1,
      titleKo: "교량계측관리",
      titleEn: "Bridge Management",
      desc:
        "교량에 계측 시스템 설치 및 시스템 개발을 운영합니다. 센서 데이터 분석을 통한 안전·효율적 관리 지원 합니다.",
      to: "/project/bms",
    },
    {
      id: "bim",
      box: box2,
      icon: ico2,
      titleKo: "지능형 시설물 관리",
      titleEn: "Smart Structure Management System​",
      desc:
        "교량과 지하차도를 비롯한 다양한 구조물을 스마트하게 진단하고 관리합니다. 정밀한 분석과 편리한 시스템을 통해 누구나 안전하고 효율적인 유지관리가 가능하게 합니다.​",
      to: "/project/bim",
    },
    {
      id: "cc",
      box: box3,
      icon: ico3,
      titleKo: "컨택센터",
      titleEn: "Contact Center Software",
      desc:
        "컨택센터 운영 전반을 아우르는 맞춤형 솔루션을 통해 안정적이고 유연한 고객 상담 환경을 지원합니다.",
      to: "/project/cc",
    },
  ];

  return (
    <section id="project" className="project">
      <div className="container-lg" style={{ maxWidth: 1100 }}>
        {/* 섹션 타이틀 */}
        <h2
          className="mb-4"
          data-aos="fade-up"
          data-aos-duration="800"
          style={{
            textAlign: "left",
            fontFamily: "'Pretendard GOV','Pretendard','Nanum Gothic',sans-serif",
            fontWeight: 800,
            fontSize: "clamp(32px,4.2vw,60px)",   // Size: 60
            color: "#cfbe94",                      // Color: #cfbe94
            letterSpacing: ".01em",
          }}
        >
          Business
        </h2>

        <div className="row g-4 g-lg-5" data-aos="fade-up" data-aos-duration="900">
          {cards.map((c) => (
            <div key={c.id} className="col-12 col-md-6 col-lg-4">
              <article className="biz-card" style={{ backgroundImage: `url(${c.box})` }}>
                {/* 어두운 오버레이 */}
                <div className="biz-card__scrim" />

                {/* 콘텐츠 */}
                <div className="biz-card__body">
                  <img src={c.icon} alt="" className="biz-card__icon" />

                  <div className="biz-card__title-ko">{c.titleKo}</div>
                  <div className="biz-card__title-en">{c.titleEn}</div>

                  <p className="biz-card__desc">{c.desc}</p>

                  <div className="biz-card__cta">
                    <Link to={c.to} className="biz-card__btn">More</Link>
                  </div>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Project;
